import {View} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import Ball from '../../component/ball';
import {DiceResultItem} from '../../dice-service';
import DiceItem from '../../component/dice-item';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import dayjs from 'dayjs';
import {packageId} from '@/config';

const ResultItem = (
  props: DiceResultItem & {
    index?: number;
    isLast?: boolean;
    countHasBg?: boolean;
  },
) => {
  const {
    openTime,
    totalCount,
    bigOrSmall,
    oddOrEven,
    result = '',
    index = 0,
    isLast,
    countHasBg,
  } = props;

  const backgroundColor = React.useMemo(() => {
    return {
      backgroundColor: index % 2 === 0 ? theme.basicColor.white : '#F8F9FF',
    };
  }, [index]);

  const resultArr = React.useMemo(() => {
    return result.split(',');
  }, [result]);

  const {calcActualSize} = useScreenSize();

  return (
    <View
      style={[
        backgroundColor,
        isLast && {
          borderBottomLeftRadius: theme.borderRadiusSize.m,
          borderBottomRightRadius: theme.borderRadiusSize.m,
        },
      ]}>
      <View style={styles.row}>
        <View style={[styles.issueCol]}>
          <Text calc size="small" style={styles.issueText}>
            {packageId === 101
              ? props.issNo
              : dayjs(openTime).format('DD-MM-YYYY\nhh:mm A')}
          </Text>
        </View>
        <View style={[styles.resultCol, theme.flex.row, theme.flex.center]}>
          {resultArr.map((item, _i) => (
            <DiceItem
              diceSize={calcActualSize(24)}
              diceNum={Number(item)}
              key={_i}
            />
          ))}
        </View>

        <View style={[styles.sumCol, theme.flex.center]}>
          {countHasBg ? (
            <View style={[theme.flex.center, {height: calcActualSize(24)}]}>
              <View style={[theme.position.abs]}>
                <DiceItem diceNum={'ball'} diceSize={calcActualSize(24)} />
              </View>
              <Text
                fontFamily="fontDinBold"
                calc
                textAlign="center"
                size="medium">
                {totalCount || '-'}
              </Text>
            </View>
          ) : (
            <Text calc textAlign="center" size="medium" style={styles.sumText}>
              {totalCount || '-'}
            </Text>
          )}
        </View>
        <View style={[styles.valueCol, theme.flex.center]}>
          {bigOrSmall === 0 ? (
            <Text calc size="medium" style={styles.emptyText}>
              -
            </Text>
          ) : (
            <Ball
              isNum={false}
              ballSize={24}
              type={bigOrSmall === 1 ? 'big' : 'small'}
            />
          )}
        </View>
        <View style={[styles.numberCol, theme.flex.center]}>
          {oddOrEven === 0 ? (
            <Text calc size="medium" style={styles.emptyText}>
              -
            </Text>
          ) : (
            <Ball
              isNum={false}
              ballSize={calcActualSize(24)}
              type={oddOrEven === 1 ? 'odd' : 'even'}
            />
          )}
        </View>
      </View>
    </View>
  );
};

const styles = {
  row: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const,
    marginHorizontal: theme.paddingSize.l,
    paddingVertical: theme.paddingSize.l,
  },
  issueCol: {
    width: 72,
  },
  issueText: {
    lineHeight: 17,
    color: '#31373D',
  },
  sumText: {
    color: '#31373D',
  },
  resultCol: {
    width: 72,
  },
  sumCol: {
    width: 27,
  },
  valueCol: {
    width: 38,
  },
  numberCol: {
    width: 50,
  },
  emptyText: {
    color: '#31373D',
  },
};

export default ResultItem;
